/* ============================================================
   NOX · Capa global de animaciones (runtime)
   - Revela cada <section.shopify-section> de <main> al entrar en viewport.
   - Aplica stagger a los hijos del contenedor principal de cada seccion.
   - Marca tarjetas/imagenes/botones para microinteracciones (hover).
   - Red de seguridad: si algo falla o no hay IntersectionObserver,
     se muestra todo. Respeta prefers-reduced-motion.
   ============================================================ */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Muestra todo (quita el gate) — usado como fallback
  function revealAll() {
    try {
      document.querySelectorAll('main .shopify-section').forEach(function (s) { s.classList.add('nox-in'); });
    } catch (e) {}
    root.classList.remove('nox-anim');
  }

  if (reduce || !('IntersectionObserver' in window)) { revealAll(); return; }

  // Selectores de "contenido que no se debe esconder/mover" (barras fijas, popups)
  var SKIP = '.sticky-atc,[data-sticky],.promo-popup,.vp-timer-sticky,.announcement,.scroll-to-top';

  function tagMicro(scope) {
    // Tarjetas: levantar al hover
    scope.querySelectorAll(
      '.card, .card-wrapper, [class*="card__"], [class*="-card"], .nox-card, .grid__item .media, .collection-list__item'
    ).forEach(function (el) { el.classList.add('nox-lift'); });

    // Contenedores de imagen: zoom suave
    scope.querySelectorAll('.media, .card__media, [class*="image"], picture').forEach(function (el) {
      if (el.querySelector && el.querySelector('img')) el.classList.add('nox-zoom');
    });

    // Botones / CTAs: realce + brillo
    scope.querySelectorAll(
      '.button, .btn, [class*="button"], button[name="add"], a.cta, .shopify-payment-button__button'
    ).forEach(function (el) { el.classList.add('nox-btn'); });
  }

  function setupSection(section) {
    if (section.matches(SKIP) || section.querySelector(SKIP) === section) return;
    // Si la seccion ES/contiene una barra fija o popup, no la escondemos
    if (section.querySelector('.sticky-atc, [data-sticky], .promo-popup, .vp-timer-sticky')) {
      section.classList.add('nox-skip');
    }
    // Elegir el contenedor principal para hacer stagger de sus hijos
    var inner = section.firstElementChild;
    // bajar hasta un contenedor con varios hijos (fila/grid), max 3 niveles
    var depth = 0;
    while (inner && inner.children && inner.children.length === 1 && depth < 3) {
      inner = inner.firstElementChild; depth++;
    }
    if (inner && inner.children && inner.children.length >= 2 && inner.children.length <= 12) {
      inner.classList.add('nox-stagger');
    }
    tagMicro(section);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('nox-in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function init(scope) {
    var sections = (scope || document).querySelectorAll('main .shopify-section');
    sections.forEach(function (s) {
      if (s.__nox) return; s.__nox = true;
      setupSection(s);
      // Si ya esta dentro del viewport al cargar, revelar sin esperar scroll
      var r = s.getBoundingClientRect();
      if (r.top < (window.innerHeight * 0.92) && r.bottom > 0) {
        s.classList.add('nox-in');
      } else {
        io.observe(s);
      }
    });
  }

  function start() {
    if (window.__noxGate) { clearTimeout(window.__noxGate); window.__noxGate = null; }
    try { init(document); } catch (e) { revealAll(); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }

  // Editor de temas: revelar al cargar/seleccionar secciones
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (ev) {
      ev.target.classList && ev.target.classList.add('nox-in');
      init(document);
    });
  }

  // Red de seguridad absoluta
  setTimeout(function () {
    document.querySelectorAll('main .shopify-section:not(.nox-in)').forEach(function (s) {
      var r = s.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) s.classList.add('nox-in');
    });
  }, 2500);
})();
